import { setUserDataToLocalStorage } from 'src/util/setUserDataToLocalStorage';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { fetchProjects } from './ProjectAction';
import { getSelf, authenticate, resetPassword } from '../services/napi';
import {
  // LOGIN_START,
  // LOGIN_FAIL,
  AUTH_SUCCESS,
  INIT_SUCCESS,
  AUTH_FAIL,
  LOGOUT_SUCCESS
} from '../constant/actionType';
import logger from '../util/logger';

const store = window.localStorage;

export function initFromStorage() {
  return async (dispatch) => {
    try {
      const sessionId = getDataFromLocalStorage(LocalStorageKey.SESSION_ID);

      logger.debug(`Read ${sessionId} from localstorage`);

      const { data } = await getSelf(sessionId);

      const user = data?.user;

      setUserDataToLocalStorage({
        role: user?.role
      });

      logger.debug(`Data ${JSON.stringify(data)} from self`);

      dispatch(fetchProjects(() => dispatch({ data, type: INIT_SUCCESS })));
    } catch (error) {
      dispatch({ data: {}, type: AUTH_FAIL });
    }
  };
}

export function authSuccess(user, sessionId) {
  return (dispatch) => {
    try {
      dispatch({ data: { sessionId, user }, type: AUTH_SUCCESS });
    } catch (error) {
      dispatch({ data: {}, type: AUTH_FAIL });
    }
  };
}

export function logOut(onSuccess) {
  return async (dispatch) => {
    try {
      dispatch({ data: {}, type: LOGOUT_SUCCESS });
      store.clear();
      onSuccess();
    } catch (error) {
      dispatch({ data: {}, type: AUTH_FAIL });
    }
  };
}

export function login(username, password, onSuccess, onFail) {
  return async (dispatch) => {
    try {
      const response = await authenticate(username, password);
      const { sessionId, user } = response.data;

      setUserDataToLocalStorage({
        role: user.role,
        sessionId
      });

      dispatch(authSuccess(user, sessionId));
      dispatch(fetchProjects(() => onSuccess));
    } catch (error) {
      onFail();
    }
  };
}

export function reset(email, onSuccess, onFail) {
  return async () => {
    try {
      await resetPassword(email);

      onSuccess();
    } catch (error) {
      onFail();
    }
  };
}

// // newly added
// export function logoutSuccess() {
//   return {
//     type: LOGOUT_SUCCESS,
//     message: "Success",
//   };
// }

// export function login(email, password, onSuccess) {
//   return async (dispatch) => {
//     try {
//       dispatch(startAuth());

//       const response = await napiService.authenticate(email, password);

//       dispatch(loginSuccess(response.data));
//       dispatch(fetchProjects());
//       onSuccess();
//     } catch (error) {
//       dispatch(loginError());
//     }
//   };
// }
